import React, {FC, useState, useEffect} from "react"

import Loading from "@irati/ui/src/Loading"
import walletService from "@irati/wallet/graph/wallet"
import authentication from "@irati/auth"
import {PaymentProvider, WalletEntityType} from "@irati/types"
import {hangPromise} from "@irati/utils/promise"
import {PerksPaymentSelectOnChange} from "@shared/payments/types"
import basket from "@irati/checkout/utils/basket"

interface Props {
  onChange: PerksPaymentSelectOnChange
  currency: string
}

const PayByUserWallet: FC<Props> = ({onChange, currency}: Props) => {
  const [load, setLoad] = useState<Promise<any>>(hangPromise())
  const price = basket.breakdown.total.amount

  useEffect(() => {
    ;(async () => {
      // force refetch wallet
      const request = walletService.get(authentication.user().uuid!, currency, WalletEntityType.User, {fetchPolicy: "network-only"})
      setLoad(request)
      onChange([{type: PaymentProvider.Wallet, amount: price}])
    })()
  }, [])

  // returning nothing for now
  return <Loading load={load} />
}

export default PayByUserWallet
